import React, { Component } from 'react'
import { compose } from 'react-apollo'

import { getValidationErrors } from 'helpers/validation'

import { removeProject as removeProjectMutation } from 'components/ProjectRemover/mutations'

import ConfirmDialog from 'components/ConfirmDialog'

class ProjectRemover extends Component {
  state = {
    isRemoving: false,
    inputs: {
      verificationPhrase: ''
    },
    errors: {
      verificationPhrase: [],
      general: []
    }
  }

  handleInputChange = (key, value) => {
    this.setState({
      inputs: {
        ...this.state.inputs,
        [key]: value
      }
    })
  }

  handleRemove = async () => {
    try {
      this.setState({
        isRemoving: true,
        errors: {
          verificationPhrase: [],
          general: []
        }
      })

      await this.props.removeProject({
        projectId: this.props.project._id,
        verificationPhrase: this.state.inputs.verificationPhrase
      })

      this.setState({
        isRemoving: false
      }, () => {
        this.props.onRemoved()
      })
    } catch (error) {
      this.setState({
        isRemoving: false,
        errors: {
          ...this.state.errors,
          ...getValidationErrors(error)
        }
      })
    }
  }

  handleCancel = () => {
    this.props.onCancel()
  }

  render() {
    return (
      <ConfirmDialog
        variant="danger"

        title="Remove project"
        description="Verify that you want to remove this project."

        cancelLabel="Cancel"
        confirmLabel="Remove"

        hasVerificationPhrase
        isVerificationPhraseValid={this.props.project.name === this.state.inputs.verificationPhrase}
        verificationPhrasePlaceholder={`Write "${this.props.project.name}" to confirm removal`}
        verificationPhraseValue={this.state.inputs.verificationPhrase}
        verificationPhraseErrors={this.state.errors.verificationPhrase}
        onVerificationPhraseChange={value => this.handleInputChange('verificationPhrase', value)}

        generalErrors={this.state.errors.general}

        isWorking={this.state.isRemoving}

        onCancel={this.handleCancel}
        onConfirm={this.handleRemove}
      />
    )
  }
}

export default compose(
  removeProjectMutation
)(ProjectRemover)



// WEBPACK FOOTER //
// ./src/components/ProjectRemover/index.js